export type Step1ToStep2Action = "full" | "resume" | "append";

/** Decide how Step 1 should transition to Step 2 based on existing rating forms vs candidates. */
export function resolveStep1ToStep2Action(
	isStep1FormCreated: boolean,
	ratingCount: number,
	candidateCount: number,
): Step1ToStep2Action {
	if (!isStep1FormCreated || ratingCount <= 0) return "full";
	if (ratingCount === candidateCount) return "resume";
	if (ratingCount < candidateCount) return "append";
	return "full";
}
